<template>
<!--  unique-opened-->
<!--  #040728-->
  <div id="left-main" style="overflow: hidden; ">
    <div class="left" style="overflow: auto">
      <div class="left-content">
        <el-row >
          <el-col>
            <el-menu
              default-active="1"
              class="el-menu-vertical-demo"
              background-color="#00294F"
              text-color="#fff"
              active-text-color="#ffd04b">

              <el-menu-item index="1"  @click="selectOption(1)">
                <i class="el-icon-menu"></i>
                <span slot="title">设备概括</span>
              </el-menu-item>

              <el-submenu index="2" v-if="meteFlg">
                <template slot="title">
                  <img src="../img/mete.png">
                  <span>气象监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="2-1"  @click="selectOption(2)">实时数据</el-menu-item>
                  <el-menu-item index="2-2"  @click="selectOption(3)">历史数据</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="5" v-if="soilFlg">
                <template slot="title">
                  <img src="../img/soil.png"/>
                  <span>墒情监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="5-1"  @click="selectOption(11)">实时数据</el-menu-item>
                  <el-menu-item index="5-2"  @click="selectOption(12)">历史数据</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="3" v-if="pestFlg">
                <template slot="title">
                  <img src="../img/bug.png">
                  <span>虫情监测</span>
                </template>
                <el-menu-item-group>
<!--                  <el-menu-item index="3-1"  @click="selectOption(4)">实时数据</el-menu-item>-->
                  <el-menu-item index="3-2"  @click="selectOption(5)">图片分析</el-menu-item>
                  <el-menu-item index="3-3"  @click="selectOption(6)">虫情统计</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="4" v-if="sporeFlg">
                <template slot="title">
                  <img src="../img/spore.png"/>
                  <span>孢子监测</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="4-1"  @click="selectOption(8)">指令控制</el-menu-item>
                  <el-menu-item index="4-2"  @click="selectOption(9)">图片分析</el-menu-item>
<!--                  <el-menu-item index="4-3"  @click="selectOption(10)">孢子趋势</el-menu-item>-->
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="7" v-if="mouseFlg">
                <template slot="title">
                  <img src="../img/mouse.png"/>
                  <span>鼠情监测</span>
                </template>
                <el-menu-item-group>
                  <!--                  <el-menu-item index="4-1"  @click="selectOption(8)">实时数据</el-menu-item>-->
                  <el-menu-item index="7-2"  @click="selectOption(14)">图片分析</el-menu-item>
                  <!--                  <el-menu-item index="4-3"  @click="selectOption(10)">孢子趋势</el-menu-item>-->
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="8"  v-if="targetFlg">
                <template slot="title">
                  <img src="../img/target.png"/>
                  <span>靶标监测</span>
                </template>
                <el-menu-item-group>
<!--                  <el-menu-item index="8-1"  @click="selectOption(15)">实时数据</el-menu-item>-->
                  <el-menu-item index="8-2"  @click="selectOption(16)">图片分析</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="9" v-if="lampFlg">
                <template slot="title">
                  <img src="../img/inse.png"/>
                  <span>杀虫灯</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="9-1"  @click="selectOption(17)">实时数据</el-menu-item>
                  <el-menu-item index="9-3"  @click="selectOption(19)">历史数据</el-menu-item>
                  <el-menu-item index="9-2"  @click="selectOption(18)">指令控制</el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-menu-item index="6" @click="selectOption(13)" v-if="seedFlg">
                <img src="../img/seed.png"/>
                <span slot="title" >苗情监测</span>
              </el-menu-item>

<!--              <el-menu-item index="7" @click="selectOption(14)">-->
<!--                <img src="../img/inse.png"/>-->
<!--                <span slot="title" >杀虫灯</span>-->
<!--              </el-menu-item>-->

            </el-menu>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  //#020c28
  export default {
    name: "Left",
    components: {},
    data() {
      return {
        meteFlg: false,
        soilFlg: false,
        pestFlg: false,
        sporeFlg: false,
        mouseFlg: false,
        targetFlg: false,
        lampFlg: false,
        seedFlg: false,
      }
    },

    mounted() {
    },

    methods: {
      /**
       * 获取选中的画面id
       * @param index
       */
      selectOption(index) {
        this.$emit("callBackInfo", index);
      },

      soilMeteShow(seedNum, meteNum, soilNum, fxscdNum) {
        if(seedNum > 0) {
          this.seedFlg = true;
        }

        if(meteNum > 0) {
          this.meteFlg = true
        }

        if(soilNum > 0) {
          this.soilFlg = true;
        }

        if(fxscdNum > 0) {
          this.lampFlg = true;
        }
      },

      sporeShow(sporeNum) {
        if(sporeNum > 0) {
          this.sporeFlg = true;
        }
      },

     insectShow(insectNum) {
       if(insectNum > 0) {
         this.pestFlg = true;
       }
     }
    }
  }
</script>

<style lang="less">
  @import "../less/Left";
</style>

<style>
  .left::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Left.vue